import { SensorOrSubSensorInfoByType } from '@components/cockpit/panels/monitoring/monitoring.types';
import { getSensorHexColor } from '@utils/sensors/sensors.utils';

import { Coordinates } from '@/types/commons/commons.types';
import { SensorTypeEnum } from '@/types/sensor/sensors';

import { SensorSection, SensorSectionFactory } from '../../../GlobalTab';
import Section from '../../Section';
import { maintenanceAndCommandSection } from '../MaintenanceAndCommandSection';
import { AutomatonCabinetSection } from './CabinetSection';

type AutomatonSectionProps = SensorOrSubSensorInfoByType<SensorTypeEnum.AUTOMATON>;

function AutomatonConnectionAndData({ configuration }: Readonly<AutomatonSectionProps>): SensorSection {
  return [
    <Section
      key="connection-section"
      operatingValues={new Map([])}
      metricsValues={new Map([])}
      informationValues={
        new Map<string, string | number | Coordinates | null | undefined>([
          ['position', configuration.sensorPosition],
          ['ip', configuration.host],
          ['port', configuration.port],
        ])
      }
    />,
    null,
  ];
}

function AutomatonCabinetByIndex({
  sensorOrSubSensorInfo,
  index,
}: Readonly<{
  sensorOrSubSensorInfo: SensorOrSubSensorInfoByType<SensorTypeEnum.AUTOMATON>;
  index: number;
}>): SensorSection {
  if (sensorOrSubSensorInfo.configuration.cabinets.length <= index) {
    return [null, null];
  }

  const configuration = sensorOrSubSensorInfo.configuration.cabinets[index];
  const status =
    sensorOrSubSensorInfo.status?.subSensorStatuses.find((status) => status.uniqueKey === configuration.uniqueKey) ??
    null;

  return [
    <AutomatonCabinetSection key={configuration.uniqueKey} configuration={configuration} status={status} />,
    getSensorHexColor({
      configuration,
      status,
      ...configuration,
      active: sensorOrSubSensorInfo.configuration.active && configuration.active,
    }),
  ];
}

export const AutomatonSections = new Map<
  string | ((sensorOrSubSensorInfo: SensorOrSubSensorInfoByType<SensorTypeEnum.AUTOMATON>) => string),
  SensorSectionFactory<SensorTypeEnum.AUTOMATON>
>([
  maintenanceAndCommandSection,
  ['automaton.connexionAndData', AutomatonConnectionAndData],
  [
    (sensorOrSubSensorInfo) => sensorOrSubSensorInfo.configuration.cabinets[0]?.name,
    (sensorOrSubSensorInfo) => AutomatonCabinetByIndex({ sensorOrSubSensorInfo, index: 0 }),
  ],
  [
    (sensorOrSubSensorInfo) => sensorOrSubSensorInfo.configuration.cabinets[1]?.name,
    (sensorOrSubSensorInfo) => AutomatonCabinetByIndex({ sensorOrSubSensorInfo, index: 1 }),
  ],
  [
    (sensorOrSubSensorInfo) => sensorOrSubSensorInfo.configuration.cabinets[2]?.name,
    (sensorOrSubSensorInfo) => AutomatonCabinetByIndex({ sensorOrSubSensorInfo, index: 2 }),
  ],
]);
